/**
 * @ngdoc controllers
 * @memberof mercury.modules.time.compliance.payrules
 * @name TimeCompliancePayRulesListCtrl
 */
angular.module('mercury.modules.time.compliance.payrules')
.controller('TimeCompliancePayRulesListCtrl', ["$filter", "$scope", "title", "PayRules", "PayRuleConstant", "userinfo", function($filter, $scope, title, PayRules, PayRuleConstant, userinfo) {
  title.set('Enabled Pay Adjustment Packages');

  var enabledPackages = [];
  var disabledpackages = [];

  $scope.showDisabledPackages = false;
  $scope.errorMessage = null;
  $scope.displayedPackages = [];
  $scope.hasManagerPermissions = userinfo.companyHasPermission('Manager');

  $scope.loading = PayRules.getAll();
  $scope.loading.then(function(allPackages) {
    enabledPackages = $filter('filter')(allPackages, function(package) {
      return package.activation != null;
    });

    disabledpackages = $filter('filter')(allPackages, function(package) {
      return package.activation == null && package.type == PayRuleConstant.PackageType.UserDefined;
    });

    $scope.displayedPackages = enabledPackages;
  }, function() {
    $scope.errorMessage = 'Failed to load enabled packages';
  });

  $scope.getPackageIcon = function(package) {
    var icon = '';
    if (package.type === PayRuleConstant.PackageType.Managed) {
      icon = PayRuleConstant.PackageTypeIcon.Managed;
    } else {
      icon = PayRuleConstant.PackageTypeIcon.Custom;
    }
    return icon;
  };

  $scope.getPackageIconTooltip = function(package) {
    var tooltip = '';
    if (package.type === PayRuleConstant.PackageType.Managed) {
      tooltip = PayRuleConstant.PackageTypeIconToolip.Managed;
    } else {
      tooltip = PayRuleConstant.PackageTypeIconToolip.Custom;
    }
    return tooltip;
  };

  $scope.toggleShowDisabledPackages = function() {
    $scope.showDisabledPackages = !$scope.showDisabledPackages;

    if ($scope.showDisabledPackages) {
      $scope.displayedPackages = disabledpackages;
    } else {
      $scope.displayedPackages = enabledPackages;
    }
  };

}]);
